import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import TableViewToggles, { type TableViewTogglesViewType } from '@rio-cloud/rio-uikit/TableViewToggles';
import type { RootState } from '../../../../../configuration/setup/store';

export interface TagListToolbarState {
    tableViewType: TableViewTogglesViewType;
    isTagCreationDialogOpen: boolean;
    searchString: string;
}

export const initialState: TagListToolbarState = {
    tableViewType: TableViewToggles.VIEW_TYPE_TABLE,
    isTagCreationDialogOpen: false,
    searchString: '',
};

const tagListToolbarSlice = createSlice({
    name: 'tagListToolbar',
    initialState,
    reducers: {
        tagsTableViewTypeChanged: (state, action: PayloadAction<TableViewTogglesViewType>) => {
            state.tableViewType = action.payload;
        },
        tagsTableSearchChanged: (state, action: PayloadAction<string>) => {
            state.searchString = action.payload;
        },
    },
});

export const { tagsTableViewTypeChanged, tagsTableSearchChanged } = tagListToolbarSlice.actions;

export default tagListToolbarSlice.reducer;

export function getTableViewType(state: RootState): TableViewTogglesViewType {
    return state.tagsTableToolbar.tableViewType;
}

export function getSearchString(state: RootState): string {
    return state.tagsTableToolbar.searchString;
}
